export enum LoanRefIndex {
    SOFR = 'SOFR',
    SOFR1M = 'SOFR1M',
    SOFR3M = 'SOFR3M',
    SOFR6M = 'SOFR6M',
    SONIA = 'SONIA',
    LIBOR = 'LIBOR',
}
